<template>
  <div class="index bg-181a20">
    <!-- 导航 -->
    <ao-nav navName='index'></ao-nav>

    <!-- <div class="relative">
      <div class="absolute svg-img1">
        <img src="@/assets/new3/bannerImg.c079820a.png" alt="" />
      </div>
    </div> -->
    <div>
      <!-- 用户共同选择 -->
      <div class="p-lr-188">
        <!-- <div class="p-t-40 relative">
          <div class="font-70 p-b-60 w-full50 wow fadeInUp animated" style="font-weight: bold;">{{$t('langNew2.zzjptgmnr')}}</div>
         <div class="flex p-b-60 wow fadeInUp animated" style="z-index: 999999;">
           <a class="a-hover" @mouseover="showhover(1)" @mouseout="hidehover" v-show="android_link" :href="android_link" title="Android" target="_blank">
             <div class="android-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-43" src="@/assets/new3/anzhuo.png" />
                 <img class="icon-mobile-show w-43 h-43" src="@/assets/new3/anzhuo-white.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">Google Play</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(2)" @mouseout="hidehover" v-show="tf_link" :href="tf_link" title="IPhone(Testflight)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">IOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(3)" @mouseout="hidehover" v-show="ios_link" :href="ios_link" title="IPhone(Signature)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(4)" @mouseout="hidehover" v-show="ios_link_2" :href="ios_link_2" title="" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>

           <a class="a-hover" @mouseover="showhover(5)" @mouseout="hidehover" v-show="ios_current_link" :href="ios_current_link" title="IPhone(Signature)" target="_blank">
             <div class="ios-btn flex-content br-10 p-lr-20 w-250 h-94 b-2-000 m-l-20">
               <div class="">
                 <img class="icon-mobile-hide w-43 h-52" src="@/assets/new3/ios-b@2x.png" />
                 <img class="icon-mobile-show w-43 h-52" src="@/assets/new3/ios-white@2x.png" />
               </div>
               <div class="p-l-10">
                 <div class="c-000 font-14">iOS App Store</div>
               </div>
             </div>
           </a>
         </div>

         <div class="qr-android" style="z-index: 99999;" v-show="hover == 1">
           <qriously :value="android_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 2">
           <qriously :value="tf_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 3">
           <qriously :value="ios_link" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 4">
           <qriously :value="ios_link_2" :size="128"/>
         </div>
         <div class="qr-ios" style="z-index: 99999;" v-show="hover == 5">
           <qriously :value="ios_current_link" :size="128"/>
         </div>

         <div class="wow fadeInUp animated" data-wow-delay=".5s">
           <div class="p-b-124">
             <div class="p-b-20">
               <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
               <span class="font-40 c-000">{{$t('langNew2.yy')}}</span>
             </div>
             <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.pqnr')}}</div>
           </div>
           <div class="p-b-124">
             <div class="p-b-20">
               <img class="w-32 h-30" src="@/assets/new3/icon_quadrangle@2x.png" alt="" />
               <span class="font-40 c-000">{{$t('langNew2.jiami')}}</span>
             </div>
             <div class="font-26 c-000 p-l-40 w-full50">{{$t('langNew2.tgnr')}}</div>
           </div>
         </div>
        </div> -->

        <div class="flex-b p-tb-60 swiper-container">
          <div class="swiper-wrapper" ref="mySwiper">
            <div class="swiper-slide flex-b" data-index="0">
              <div class="w-full50">
                <div class="c-000 font-60 font-b p-b-41 word-break">{{ $t('一应俱全的金融交易体验')}}</div>
                <div class="c-fff font-40 p-b-40">{{ $t('强大平台,超低点差,快速执行,专属支持')}}</div>
                <div class="flex p-b-40">
                  <div class="text3 cursor" @click.stop="$router.push('/ldcoin?tradeIdx=0')">
                    <span class="text3-1">{{$t("立即交易")}}</span>
                    <img src="@/assets/new7/bofang@3x.png" class="img1" />
                  </div>
                  <div class="text3 cursor textmn" @click.stop="mock">
                    <span class="text3-1 c-000">{{ $t('langNew2.cjxnzh') }}</span>
                  </div>
                </div>
                <div class="font-b p-b-30">{{$t("为什么选择FXLY？让我们的数字来说话")}}</div>
                <div class="flex-b">
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b"><span class="counter1 counter4" :data-set="num1"></span>K+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("交易者")}}</div>
                  </div>
                  <!-- <div class="op-1  m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b"><span class="counter1 counter4" :data-set="num2"></span>K+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月活跃客户")}}</div>
                  </div>
                  <!-- <div class="op-1 m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b">$<span class="counter1 counter4" :data-set="num3"></span>B+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月交易量")}}</div>
                  </div>
                  <!-- <div class="op-1 m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b">$<span class="counter1 counter4" :data-set="num4"></span>M+</div>
                    <div class="c-a0afc1 font-16 t-center h-30 t-center" style="word-break: break-all;">{{$t("每月提取金额")}}</div>
                  </div>
                </div>
              </div>
              <div class="w-full50 relative">
                <div class="relative overflow-x" style="display: flex;justify-content: end;">
                  <img class="w-682 h-550" src="@/assets/new6/home1.png"/>
                </div>
                <!-- <div class="absolute rotate90" style="width:3.5rem;height:.7rem;top:50%;right:-1.2rem">
                  <div class="swiper-pagination c-fff"></div>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div> -->
              </div>
            </div>

            <div class="swiper-slide flex-b" data-index="1">
              <div class="w-full50">
                <div class="c-000 font-60 font-b p-b-41 word-break">{{ $t('您可以信赖的经济人')}}</div>
                <div class="c-fff font-40 p-b-40">{{ $t('卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉')}}</div>
                <div class="flex p-b-40">
                  <div class="text3 cursor" @click.stop="$router.push('/ldcoin?tradeIdx=0')">
                    <span class="text3-1">{{$t("立即交易")}}</span>
                    <img src="@/assets/new7/bofang@3x.png" class="img1" />
                  </div>
                  <div class="text3 cursor textmn" @click.stop="mock">
                    <span class="text3-1 c-000">{{ $t('langNew2.cjxnzh') }}</span>
                  </div>
                </div>
                <div class="font-b p-b-30">{{$t("为什么选择FXLY？让我们的数字来说话")}}</div>
               <div class="flex-b">
                 <div class="flex-content col w-full20">
                   <div class="num-text c-fff font-48 font-b"><span class="counter2" :data-set="num1"></span>K+</div>
                   <div class="c-a0afc1 font-16 t-center h-30">{{$t("交易者")}}</div>
                 </div>
                 <!-- <div class="op-1  m-lr-40"></div> -->
                 <div class="flex-content col w-full20">
                   <div class="num-text c-fff font-48 font-b"><span class="counter2" :data-set="num2"></span>K+</div>
                   <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月活跃客户")}}</div>
                 </div>
                 <!-- <div class="op-1 m-lr-40"></div> -->
                 <div class="flex-content col w-full20">
                   <div class="num-text c-fff font-48 font-b">$<span class="counter2" :data-set="num3"></span>B+</div>
                   <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月交易量")}}</div>
                 </div>
                 <!-- <div class="op-1 m-lr-40"></div> -->
                 <div class="flex-content col w-full20">
                   <div class="num-text c-fff font-48 font-b">$<span class="counter2" :data-set="num4"></span>M+</div>
                   <div class="c-a0afc1 font-16 t-center h-30 t-center" style="word-break: break-all;">{{$t("每月提取金额")}}</div>
                 </div>
               </div>
              </div>
              <div class="w-full50 relative">
                <div class="relative overflow-x" style="display: flex;justify-content: end;">
                  <img class="w-740 h-623" src="@/assets/new6/home2.png"/>
                </div>
                <!-- <div class="absolute rotate90" style="width:3.5rem;height:.7rem;top:50%;right:-1.2rem">
                  <div class="swiper-pagination c-fff"></div>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div> -->
              </div>
            </div>

            <div class="swiper-slide flex-b" data-index="2">
              <div class="w-full50">
                <!-- <div class="c-000 font-60 font-b p-b-41 word-break">{{ $t('强大的交易技术专属体验')}}</div>
                <div class="c-fff font-40 p-b-40">{{ $t('与整体满意度最高的供应商交易差价合约，把握更好的交易时机')}}</div> -->
                <div class="c-000 font-60 font-b p-b-41 word-break">{{ $t('顶尖交易技术')}}</div>
                <div class="c-fff font-40 p-b-40">{{ $t('通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！')}}</div>
                <div class="flex p-b-40">
                  <div class="text3 cursor" @click.stop="$router.push('/ldcoin?tradeIdx=0')">
                    <span class="text3-1">{{$t("立即交易")}}</span>
                    <img src="@/assets/new7/bofang@3x.png" class="img1" />
                  </div>
                  <div class="text3 cursor textmn" @click.stop="mock">
                    <span class="text3-1 c-000">{{ $t('langNew2.cjxnzh') }}</span>
                  </div>
                </div>
                <div class="font-b p-b-30">{{$t("为什么选择FXLY？让我们的数字来说话")}}</div>
                <div class="flex-b">
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b"><span class="counter3" :data-set="num1"></span>K+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("交易者")}}</div>
                  </div>
                  <!-- <div class="op-1  m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b"><span class="counter3" :data-set="num2"></span>K+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月活跃客户")}}</div>
                  </div>
                  <!-- <div class="op-1 m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b">$<span class="counter3" :data-set="num3"></span>B+</div>
                    <div class="c-a0afc1 font-16 t-center h-30">{{$t("每月交易量")}}</div>
                  </div>
                  <!-- <div class="op-1 m-lr-40"></div> -->
                  <div class="flex-content col w-full20">
                    <div class="num-text c-fff font-48 font-b">$<span class="counter3" :data-set="num4"></span>M+</div>
                    <div class="c-a0afc1 font-16 t-center h-30 t-center" style="word-break: break-all;">{{$t("每月提取金额")}}</div>
                  </div>
                </div>
              </div>
              <div class="w-full50 relative">
                <div class="relative overflow-x" style="display: flex;justify-content: end;">
                  <img class="w-740 h-550" src="@/assets/new6/home3.png"/>
                </div>
                <!-- <div class="absolute rotate90" style="width:3.5rem;height:.7rem;top:50%;right:-1.2rem">
                  <div class="swiper-pagination c-fff"></div>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div> -->
              </div>
            </div>

          </div>
          <div class="swiper-pagination"></div>
        </div>



      </div>
      <!-- 公告 -->
      <!-- <div class="notice-wrap m-t-110 wow fadeInUp animated">
         <div class="notice" v-show="noticeList.length > 0" v-if="lang == 'ar'">
           <router-link tag="div" class="notice-more" to="/notice" >{{$t('bzhl.ckgd')}}</router-link>
           <div class="notice-item">
             <span
               v-for="(item, index) in noticeList"
               :key="index"
               @click="notice(item.id)"
             >{{ item.title }}</span>
           </div>
           <div class="notice-new flex-content c-000 font-18">NEW</div>
         </div>
         <div class="notice" v-show="noticeList.length > 0" v-else>
           <div class="notice-new flex-content c-000 font-18">NEW</div>
           <div class="notice-item">
             <span
               v-for="(item, index) in noticeList"
               :key="index"
               @click="notice(item.id)"
             >{{ item.title }}</span>
           </div>
           <router-link tag="div" class="notice-more" to="/notice" >{{$t('bzhl.ckgd')}}</router-link>
         </div>
       </div> -->


         <div class="s_ticker  MuiBox-root mui-18oeoue">
          <div class="s_ticker_box MuiBox-root mui-k008qs">
           <ul class="MuiBox-root mui-0" v-for="(item, index) in usdtList" :key="index+'b'">
            <span class="MuiTypography-root MuiTypography-body1 mui-1k8stw6">
              <img v-show="item.icon" :src="item.icon" class="w-50 h-50" style="color: transparent; margin-right: 10px;" />
              {{ item.cname | rewriteName}}
            </span>
           </ul>
           <ul class="MuiBox-root mui-0" v-for="(item, index) in usdtList" :key="index+'a'">
            <span class="MuiTypography-root MuiTypography-body1 mui-1k8stw6">
              <img v-show="item.icon" :src="item.icon" class="w-50 h-50" style="color: transparent; margin-right: 10px;" />
              {{ item.cname | rewriteName}}
            </span>
           </ul>
          </div>
         </div>


      <!-- 交易品种市场趋势；k线分时图 -->
      <div class="p-lr-188">
        <!-- tab -->
        <!-- <div class="c-000 font-60 font-b p-tb-60 t-center wow fadeInUp animated">{{ $t('langNew9.dzje')}}</div> -->
        <div class="flex box03 ov wow fadeInUp animated br-20 p-t-60">
          <div class="w-full40" style="padding-top:1rem">
            <div class="font-60 font-b p-b-30">{{$t("dcwj.homehq1")}}</div>
            <div class="font-34 p-b-40">{{$t("dcwj.homehq2")}}</div>
            <div class="m-t-60 cursor" @click="path('/market?tabIdx=2')">
              <span class="font-20 font-b bg-fcd437 br-40 t-center" style="padding:.2rem .4rem .2rem .4rem">{{$t("dcwj.homehq3")}}</span>
            </div>
          </div>
          <div class="ov p-lr-50 w-full60">

                <market-home></market-home>
                <!-- <ul class="tab_menu ov">
                    <li :class="{cur:tabIndex==5}" @click="tab(5,1)">{{ $t('hq.wh') }}</li>
                    <li :class="{cur:tabIndex==2}" @click="tab(2,2)">{{ $t('langNew.jmhb') }}</li>
                    <li :class="{cur:tabIndex==0}" @click="tab(0,3)">{{ $t('商品') }}</li>
                </ul>
                <div class="tabox ov">
                    <div class="cont ov table-body" style=" display:block;">
                        <div class="th">
                            <div class="td td2 t-left">{{ $t('hq.mc') }}</div>
                            <div class="td td1 text-center">{{ $t('index.thead')[4] }}</div>
                            <div class="td td1 text-center">{{$t('jy.mc')}}</div>
                            <div class="td td1 text-center">{{$t('jy.mr')}}</div>
                            <div class="td td1 text-center">{{$t('hq.tb')}}</div>
                            <div class="td td1 text-right">{{ $t('index.thead')[6] }}</div>
                        </div>
                        <div class="tr" v-for="(item, index) in usdtList.slice(0,7)" :key="index">

                          <div class="td td2 t-left"><img v-show="item.icon" :src="item.icon">{{ item.cname}}</div>

                          <div class="td td1 text-center change" :class="{red2: item.change_rate < 0}">
                            {{item.change_rate}}%
                          </div>
                          <div class="td td1 text-center sell">
                            {{parseFloat(item.now_price) | toFixed4(item.now_price,item.cname)}}

                          </div>
                          <div class="td td1 text-center buy">
                            {{(parseFloat(item.now_price) + parseFloat(item.buy_add_money)).toFixed(toFixed4(item.now_price,item.cname))}}
                          </div>
                          <div class="td td1 text-center" v-if="item.prices">
                            <trend v-show="item.prices.length > 0"
                              :class="item.change_rate < 0?'fill-red m-t-20':'fill-green m-t-20'"
                              :data="item.prices.map(Number)"
                              :gradient="item.change_rate < 0?['red']:['green']"
                              :width="85"
                              :height="27"
                              auto-draw
                              smooth
                            >
                            </trend>
                          </div>
                          <div class="td td1 text-center" v-else>

                          </div>
                          <div class="td td1 text-right cursor"><img class="w-50" src="@/assets/new7/yjt.jpg" @click="link(item.cname)" alt=""></div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
      </div>

      <!-- 了解我们的平台 -->
      <!-- <div class="p-lr-188 wow fadeInUp animated" data-wow-delay=".5s">
        <div class="flex-content font-60 font-b c-000 p-tb-60">{{$t("了解我们的平台")}}</div>
        <div class="flex bg-list p-30">
          <div class="w-full50">
            <div>
              <div class="video-box">
                <iframe
                  class="w-full90 h-314"
                  src="https://www.youtube.com/embed/eAL5XVQtrxo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="p-t-30 font-24 w-full80">{{$t("我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验")}}</div>
          </div>
          <div class="flex-col font-30 c-000 w-full50 line4">
            <div class="font-24 c-000 p-b-40 row1">
              <img src="@/assets/new7/dagou@3x.png" class="img1" />
              <span class="textb">
                <span class="text1 font-24">{{$t("直观易用")}}</span>
                <span class="text2 font-24">{{$t("的界面")}}</span>
              </span>
            </div>
            <div class="font-24 c-000 p-b-40 row1">
              <img src="@/assets/new7/dagou@3x.png" class="img1" />
              <span class="textb">
                <span class="text2 font-24">{{$t("定期提供")}}</span>
                <span class="text1 font-24">{{$t("3,000多个市场")}}</span>
                <span class="text2 font-24">{{$t("的实时更新和 价格警报")}}</span>
              </span>
            </div>
            <div class="font-24 c-000 p-b-40 row1">
              <img src="@/assets/new7/dagou@3x.png" class="img1" />
              <span class="textb">
                <span class="text2 font-24">{{$t("各种技术指标")}}</span>
                <span class="text1 font-24">{{$t("分析工具和高级图表")}}</span>
              </span>
            </div>
            <div class="font-24 c-000 p-b-40 row1">
              <img src="@/assets/new7/dagou@3x.png" class="img1" />
              <span class="textb">
                <span class="text2 font-24">{{$t("套期保值模式和")}}</span>
                <span class="text1 font-24">{{$t("风险管理工具")}}</span>
              </span>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 经济舱 -->
      <div class="p-lr-188 m-b-100 bg-new wow fadeInUp animated" data-wow-delay=".5s">
        <div class="flex-content font-60 font-b c-000 p-tb-60 m-t-60">{{$t("还在找一位您可以信任的经纪商吗？")}}</div>
        <div class="flex-content font-20 c-000">{{$t("加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。")}}</div>

          <div class="flex-b br-15">
            <div class="regSteps__wrap">
              <div class="regSteps__shape">
                <i class="regSteps__item" v-on:mouseenter="imgShow(1)"  v-on:mouseleave="imgShow(0)">
                 <img v-if="imgIndex != 1" src="@/assets/new6/chuangjian.png" width="80px" />
                 <img v-if="imgIndex == 1&&!token" src="@/assets/new6/chuangjian_light.png" width="80px" @click="path('/register')" />
                 <img v-if="imgIndex == 1&&token" src="@/assets/new6/chuangjian_light.png" width="80px" />
                </i>
                <i class="regSteps__item" v-on:mouseenter="imgShow(2)"  v-on:mouseleave="imgShow(0)">
                  <img v-if="imgIndex != 2" src="@/assets/new6/cunkuan.png" width="80px" />
                  <img v-if="imgIndex == 2" src="@/assets/new6/cunkuan_light.png" width="80px" @click="path('/authenticationrj')" />
                 </i>
                <i class="regSteps__item" v-on:mouseenter="imgShow(3)"  v-on:mouseleave="imgShow(0)">
                  <img v-if="imgIndex != 3" src="@/assets/new6/jiaoyi.png" width="80px" />
                  <img v-if="imgIndex == 3" src="@/assets/new6/jiaoyi_light.png" width="80px" @click="path('/ldcoin?tradeIdx=0')" />
                 </i>
               </div>
               <div class="w-full flex-b p-lr-30 m-t-40">
                 <div class="font-28"><b>{{$t("1.创建和验证您的账户")}}</b></div>
                 <div class="font-28"><b>{{$t("2.进行存款")}}</b></div>
                 <div class="font-28"><b>{{$t("3.找到合适您的交易")}}</b></div>
               </div>

            </div>
          </div>

      </div>


      <!-- 实时新闻资讯 -->
      <div class="p-lr-188 m-b-100 bg-new wow fadeInUp animated" data-wow-delay=".5s">
        <div class="flex-content font-60 font-b c-000 p-tb-60">{{$t("实时新闻咨询")}}</div>
        <div class="flex-content font-20 c-000">{{$t("紧跟我们的新闻、产品和活动信息")}}{{$t("合作伙伴等最新新闻动态")}}</div>
        <div class="flex-content font-20 c-858b99 p-tb-60 cursor" @click="path('/settingNew')">{{$t("阅读更多新闻")}} > </div>

          <div class="flex-b br-15" v-if="newList&&newList.length">
            <!-- <div class=""> -->
              <div class="bg-list m-r-30 cursor w-full33" v-for="(item,k) in newList.slice(0,3)" :key="k" @click.stop="path('/setting-newdetail?id='+item.id)">
                <div class="">
                  <img class="w-400 img-news" v-if="item.img.length>2" :src="item.img" alt="" />
                  <img class="w-400" v-else src="@/assets/new7/get-involeved-2-_24@3x.png" alt="" />
                </div>
                <div class="bg-f3f5f7 br-20 c-000 font-14 p-10 m-30 ellipsis">{{item.title}}</div>
                <div class="font-20 c-000 ellipsis2 m-30" v-html="item.content"></div>
              </div>
            <!-- </div> -->
          </div>

        <!-- 轮播 -->
        <!-- <div style="overflow-x: clip;">
          <div class="flex-b br-15 swiper-container1">
            <div class="swiper-wrapper" ref="mySwiper1">
              <div class="swiper-slide bg-list m-r-30 cursor" v-for="(item,k) in newList" :key="k" @click.stop="path('/setting-newdetail?id='+item.id)" :data-index="k">
                <div class="">
                  <img class="w-400 img-news" v-if="item.img.length>2" :src="item.img" alt="" />
                  <img class="w-400" v-else src="@/assets/new7/get-involeved-2-_24@3x.png" alt="" />
                </div>
                <div class="bg-f3f5f7 br-20 c-000 font-14 p-10 m-30 ellipsis">{{item.title}}</div>
                <div class="font-20 c-000 ellipsis2 m-30" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div> -->

      </div>

      <!-- AI智能赚币 -->
      <!-- <div class="p-lr-188 m-b-100 ai-box wow fadeInUp animated" data-wow-delay=".5s">
        <div class="flex-content flex-col p-tb-74">
          <div class="flex-content font-60 font-b p-tb-60">{{$t("AI智能赚币")}}</div>
          <div class="w-full flex row-a">
            <div class="w-full33 p-t-100">
              <div class="flex-content flex-col p-b-100">
                <div class="font-20 c-000 bg-fcd437 br-20 p-10">{{$t("出金")}}</div>
                <div class="p-tb-10 font-28">{{$t("随存随取")}}</div>
                <div class="font-24 c-858b99">{{$t("一键即刻取出,从不等待")}}</div>
              </div>
              <div class="flex-content flex-col p-t-40">
                <div class="font-20 c-000 bg-fcd437 br-20 p-10">{{$t("稳定")}}</div>
                <div class="p-tb-10 font-28">{{$t("最稳健的理财")}}</div>
                <div class="font-24 c-858b99">{{$t("稳定收益,您的理财助手")}}</div>
              </div>
            </div>
            <div class="flex-content w-full33">
              <img class="w-400" src="@/assets/new6/xl_exness_phone_home_page_9e8292cbcc.png" alt="" />
            </div>
            <div class="w-full33 p-t-100">
              <div class="flex-content flex-col p-b-100">
                <div class="font-20 c-000 bg-fcd437 br-20 p-10">{{$t("执行速度")}}</div>
                <div class="p-tb-10 font-28">{{$t("极速执行")}}</div>
                <div class="font-24 c-858b99">{{$t("所有订单将以毫秒级别速度执行")}}</div>
              </div>
              <div class="flex-content flex-col p-t-40">
                <div class="font-20 c-000 bg-fcd437 br-20 p-10">{{$t("每天发放")}}</div>
                <div class="p-tb-10 font-28">{{$t("当天产生收益")}}</div>
                <div class="font-24 c-858b99">{{$t("当天购买当天产生收益,24小时及时发放收益")}}</div>
              </div>
            </div>
          </div>
          <div class="xz flex-content font-28 c-000 bg-fcd437 m-tb-60 cursor" @click="path('/profit_index')">
            {{$t("现在就开始")}}
          </div>
        </div>
      </div> -->

      <!-- 交易全球金融市场 -->
      <!-- <div class="p-lr-188 m-b-100">
        <div class="flex-content row-a p-tb-100 bg-list p-30 wow fadeInUp animated" data-wow-delay=".5s">
          <div class="w-full50 p-lr-30 t-center">
            <img class="" src="@/assets/new7/anim-product.svg" />
          </div>
          <div class="w-full50 p-l-30">
            <div class="flex font-60 font-b c-000 p-b-100">{{$t("交易全球金融市场")}}</div>
            <div>
              <ul>
                <li class="flex font-24 c-000 p-b-40">{{$t("支持桌面端与移动端多种方式")}}</li>
                <li class="flex font-24 c-000 p-b-40">{{$t("简单、快速、安全、合法")}}</li>
                <li class="flex font-24 c-000 p-b-40">{{$t("免费客户咨询服务")}}</li>
                <li class="flex font-24 c-000 p-b-100">{{$t("多种产品可供选择")}}</li>
              </ul>
            </div>
            <div>
              <div class="btn-app bg-fcd437 cursor">
                {{$t("下载应用程序")}}
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 背景图 -->
      <div class="p-lr-188 m-b-100">
        <img class="w-full" src="@/assets/new6/hezuo.png" alt="" />
      </div>

    </div>
    <!-- 开设账户 -->
    <!-- <div class="flex-content col w-full20 bg-img h-406 c-fff wow fadeInUp animated" v-show="!token">
      <div class="c-fff font-40">{{ $t('home.open_text')}}</div>
      <div class="flex-content br-10 w-208 h-67 bg-fcd535 c-000 font-24 m-t-60 cursor" @click="register">{{ $t('home.open_account')}}</div>
    </div> -->

    <!-- 脚部 -->
    <ao-footer></ao-footer>
    <!-- 公告弹窗 -->
    <div class="mask-notice" v-show="isNotice">
      <div class="notice-alert-wrap box-shadow-14">
          <div class="title">{{ $t('news.gg') }}</div>
          <div class="cont" v-html="noticeHtml"></div>
          <div class="notice-btn" @click="goDetail">{{ $t('news.ckxq') }}</div>
          <img class="btn-close" @click="noticeClose" src="@/assets/login_delete.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import AoNav from "@/components/AoNav";
import AoFooter from "@/components/AoFooter";
import marketHome from "@/components/marketHome";
// import areaChart from '@/components/areaChart.vue'
import pic from '@/utils/pic'

import { marke_price,number_round } from '@/utils/index'
import { getStocknews } from '@/api/asset'

// import { getGG, getmarketList, getBanner, getQrcode,getParam,getText } from "@/api/index";
var index_timer = null;
let intervalId = null;
import iconLeft from "@/assets/icon-left.png";
import iconRight from "@/assets/icon-right.png";
import iconRightHome from "@/assets/Home_banner_icon.png";
import zheXian from "@/assets/zhexian.png";
import { mapGetters } from "vuex";
import { setLang, setToken, removeToken,getLang } from "@/utils/auth";
let vm = null;
export default {
  components: {
    AoNav,
    AoFooter,
    marketHome
  },
  data() {
    return {
      //shortTickers: [{coin: "ETC",quoteUnit: "USDT"},{coin: "XIL",quoteUnit: "USDT"},{coin: "FIL",quoteUnit: "USDT"},{coin: "DOGE",quoteUnit: "USDT"}], // 顶部四个交易对
      iconbg: pic.iconbg,
      indexphone: pic.indexphone,
      bannerList: [],
      usdtList: [],
      oldList: [],
      noticeList: [],
      index: 0,
      value: '',
      dealsIndex: 0,
      tabIndex: 5,

      featureTitle2: this.$t("index.featureTitle2"),
      featureMsg2: this.$t("index.featureMsg2"),

      iconLeft:iconLeft,
      iconRight: iconRight,
      iconRightHome: iconRightHome,
      zheXian: zheXian,
      iconDirection: 1,
      lClass: '',
      rClass: '',
      type: 'text',
      swiper: null,
      swiper1: null,
      qrcode: {},
      currencyList: [],
      android_link: "",
      ios_link: "",
      tf_link: "",
      ios_link_2: "",
      ios_current_link: "",
      isNotice: false,
      noticeId: '',
      noticeHtml: '',
      isNoticeShow: '',
      lang: 'en',
      bzType: 1,
      hover:0,
      trendArr:[],//分时图数组
      // videoUrl: 'https://youtu.be/eAL5XVQtrxo',
      videoUrl: 'https://www.youtube.com/embed/eAL5XVQtrxo',
      isVideoBg: true,//视频背景
      player: null,
      webName:window.GLOBAL.title,
      newList:[],
      pageSize:9,
      page:1,
      num1:660,
      num2:86,
      num3:208,
      num4:41,
      isMn: false,
      currencyAll: '',
      downTimer: null,
      imgIndex:0,
      lockReconnect: false //soket重连
    };
  },
  computed: {
    ...mapGetters(["token"])
  },
  created(){
    vm = this;
    this.isMn = JSON.parse(localStorage.getItem('isMn'));
    this.getNewList();
    this.getFunOpen();//交易密码开关
    // this.initWebSocket();
    // this.animateValue("number",0,7565,2000)
  },
  mounted() {
    this.lang = localStorage.getItem('lang') || 'en';
    this.isNoticeShow = sessionStorage.getItem("isNoticeShow");
    this.getCurrency()
    this.startFn(1);
    this.getAllCurrency();//请求全局币种列表
    this.getNew()
    // getBanner().then(res => {
    //   this.bannerList = res;
      setTimeout(() => {
        // this.swiper = new Swiper('.swiper-container',{
        //     direction: 'vertical', // 垂直切换选项
        //     // height: 'auto',
        //     slidesPerView: 1,
        //     // spaceBetween: 30,
        //     autoplay:true,
        //     loop: true,
        //     // observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        //     // observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        //     autoplay: {
        //         delay: 2000,
        //         disableOnInteraction: false
        //     },
        //     pagination: {
        //       el: '.swiper-pagination',
        //       // type: 'custom',
        //       // type: 'fraction',
        //       clickable: true,
        //       renderBullet: function (index, className) {
        //         return '<span style="width:.5rem;height:.5rem;line-height: .5rem;" class="' + className + '">' + (index + 1) + "</span>";
        //       }
        //     },
        //     // 如果需要前进后退按钮
        //     navigation: {
        //       nextEl: '.swiper-button-next',
        //       prevEl: '.swiper-button-prev',
        //     },
        //     on:{
        //         // click: ()=>{
        //         //     let swiper = this.$refs.mySwiper.$swiper;
        //         //     let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
        //         //     vm.bannerLink(i);
        //         // }
        //     },
        // })
        // 旧版的横向轮播
        this.swiper = new Swiper('.swiper-container',{
            slidesPerView: 1,//显示多少个item
            spaceBetween: 30,
            autoplay:true,
            loop: false,//loop设置ture为循环轮播；会导致虚拟slide事件无效
            observer:true,  //修改swiper自己或子元素时，自动初始化swiper
            observeParents:true,  //修改swiper的父元素时，自动初始化swiper
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
              clickableClass: 'my-pagination-clickable',
            },
            on:{
                click: ()=>{
                  if(this.swiper.clickedSlide){
                    // let swiper = this.$refs.mySwiper.$swiper;
                    let i = JSON.parse(this.swiper.clickedSlide.attributes['data-index'].nodeValue);
                    vm.bannerLink(i);
                  }
                },
                slideChange: ()=> {
                  // var activeIndex = this.swiper.activeIndex;
                  if(this.swiper){
                    // console.log(this.swiper.activeIndex)
                    this.startFn(this.swiper.activeIndex);
                  }
                },
            },
        })
      }, 0)
    // })
   //  getGG().then(res => {
   //    var noticeArr = [];
   //    this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
   //    this.noticeList = res;

   //    if(res.length > 0){
   //      noticeArr = res.filter((item,index) =>{
			// 		if(item.pop == 1){
			// 			return true;
			// 		}else{
			// 			return ''
			// 		}
			// 	});
			// 	if(noticeArr.length > 0){
			// 		if(this.isNoticeShow){
			// 			this.isNotice = false;
			// 		}else{
			// 			this.isNotice = true;
			// 		}
			// 		this.noticeId = noticeArr[0].id;
			// 		this.getDetail(this.noticeId);
			// 	}
			// }else{
			// 	this.isNotice = false
			// }
   //   });

    // 暂时注释
    // getQrcode().then(res => {
    //   this.qrcode = res
    // });

    // getParam().then(res => {
    //   for(var i=0;i< res.length; i++){
    //     if(res[i].key == 'android_link'){
    //       this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //     }else if(res[i].key == 'ios_link'){
    //       this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //     }else if(res[i].key == 'tf_link'){
    //       this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //     }else if(res[i].key == 'online_service'){
    //       localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
    //     }else if(res[i].key == 'online_service2'){
    //       localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
    //     }else if(res[i].key == 'ios_link_2'){
    //       this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //     }else if(res[i].key == 'ios_current_link'){
    //       this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //     }
    //   }
    // });

    // 暂时注释
    // this.getParam()
    // this.getmarketList();

    // 暂时注释
    // this.initWebSocket();
    let that = this;
    // that.getNewTimeshar()

    // intervalId = setInterval(()=>{
    //   that.getNewTimeshar()
    // }, 10000);

    if(window.GLOBAL.is_sw_market){
      __socket.emit("index", 'index');
      __socket.on("daymarket", msg => {
        if (typeof msg === 'string') msg = JSON.parse(msg)
        if (msg.type == "daymarket") {
          //tabIndex 0=主流币 1=涨幅币
          var arr = this.usdtList.concat([])
          arr.forEach(o => {
            if (o.symbol == msg.symbol) {
              o.grow = number_round(msg.change, window.GLOBAL.NUMBER_ROUND_2)
              o.vol = number_round(msg.volume)
              o.new_price = number_round(marke_price(msg.now_price, o.is_control,o.buy_control_value,o.risk_value))
            }
          })
          if(this.tabIndex==1){
            this.sort(arr)
          }else{
            this.usdtList = arr
          }
        }
      });
    }

    this.$nextTick(() => {
      new this.$wow.WOW({resetAnimation: false,live: false }).init()
    })
  },
  destroyed() {
    index_timer&&clearInterval(index_timer);
    intervalId&&clearInterval(intervalId);
  },
  watch: {
    wsData(val) {
  	// console.log('watch获取的数据:',val)
  	this.globalWs(val);
    },
  },
  computed: {
    wsData() {
  	return this.$store.state.wsData;
    },
  },
  methods: {
    globalWs(e) {
    	//数据接收
    	if (e) {
    	  let msg = e ? e : JSON.parse(localStorage.getItem("currencyAll"));
    	  // localStorage.setItem("currencyAll", JSON.stringify(msg));
    	  if(typeof msg === 'object'){
    	    this.currencyAll = msg;
    	    let listData = this.usdtList.map(item =>{
    	      var obj = {change_rate: this.currencyAll[item.small_name].change_rate,new_price:this.currencyAll[item.small_name].now_price,new_price1: this.currencyAll[item.small_name].now_price};
    	      item = { ...item,...obj };
    	      return item
    	    });
    	    this.usdtList = listData;
    	  }
    	}
    },
    getAllCurrency(){
      let params = {
        main_type: ''
      }
      var url = JSON.parse(localStorage.getItem('isMn')) ? this.HOSTMn + '/api/index/getAllCurrency' : '/api/index/getAllCurrency';
      this.$ajax.post(url,params).then((res) => {
        if(res.data.code == 200){
          let resData = res.data.data;
          // this.currencyArr = resData;
          localStorage.setItem('currencyArr',JSON.stringify(resData));
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    // 获取系统公告
    getNew(){
      let params = {
        uid: this.uid,
        dg_token: this.token,
        page: 1
      }
      this.$ajax.post('/api/index/annoIndex',params).then((res) => {
          let resData = res.data.data;
          // this.noticeList = resData;
          // 是否弹框
          if(resData[0]&&resData[0].pop == 1){
            if (this.isNoticeShow) {
              this.isNotice = false;
            } else {
              this.isNotice = true;
            }
            this.noticeId = resData[0].id;
            this.noticeHtml = resData[0].content;
            return true;
          }else{
            return ''
          }
      }).catch(function(err){
          console.log(err)
      })
     },
    getFunOpen(){
      // "delivery_pw_open":"mock",                //类型：String  可有字段  备注：交割交易密码 开关 1 开启
      //     "contract_pw_open":"mock",                //类型：String  可有字段  备注：合约交易密码 开关 1 开启
      //     "exchange_pw_open":"mock",                //类型：String  可有字段  备注：兑换交易密码 开关 1 开启
      //     "coin_pw_open":"mock",                //类型：String  可有字段  备注：币币交易密码 开关 1 开启
      //     "cross_exchange":"mock",                //类型：String  可有字段  备注：兑换是否开启 交叉交易 1开启
      //     "realname_open":"mock",                //类型：String  必有字段  备注：KYC （实名认证是否开启 ）开关 1 开启
      //     "email_reg_open":"mock",                //类型：String  必有字段  备注：邮箱注册 开启 1
      //     "sms_reg_open":"mock",                //类型：String  必有字段  备注：短信注册 开启 1
      //     "withdraw_open":"mock",                //类型：String  必有字段  备注：提现开启交易密码
      //     "withdraw_usd_open":"mock",                //类型：String  必有字段  备注：数字货币提现只扣款USD
      //     "desposit_usd_open":"mock"                //类型：String  必有字段  备注：数字货币充值转USD
       let params = {
        uid: this.uid,
        dg_token: this.token
      }
      var url = '/api/index/getFunOpen';
      this.$ajax.post(url,params).then((res) => {
        let resData = res.data.data;
        if(res.data.code == 200){
          localStorage.setItem('isTradePw',JSON.stringify(resData))
        }else{
            this.$toast.center(res.data.msg);
            return;
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    onVideoLoad(event) {
      // 当iframe加载完成时，获取Player实例
      this.player = event.target.contentWindow;
    },
    playVideo() {
      if (this.player) {
        // 调用Player的play方法播放视频
        this.player.postMessage('{"event":"command","func":"playVideo","args":""}','*');
      }
    },
    toFixed4(val,cname){
       var leng;
       var defval = parseFloat(val);
       if(cname){
         if(cname == 'AUDUSD' || cname == 'GBPUSD' || cname == 'EURUSD' || cname == 'NZDUSD' || cname == 'USDCAD' || cname == 'USDCHF' || cname == 'USDCNH' || cname == 'USDHKD' || cname == 'USDSGD' || cname == 'EURAUD' || cname == 'EURCAD' || cname == 'EURGBP' || cname == 'EURNZD' || cname == 'GBPAUD' || cname == 'GBPCAD' || cname == 'GBPCHF' || cname == 'GBPNZD' || cname == 'NZDCAD' || cname == 'NZDCHF' || cname == 'CADCHF' || cname == 'AUDCAD' || cname == 'AUDCHF' || cname == 'XRPUST' || cname == 'XRP'){
           leng = 5
         }else if(cname == 'USDJPY' || cname == 'EURJPY' || cname == 'GBPJPY' || cname == 'NZDJPY' || cname == 'AUDNZD' || cname == 'CADJPY' || cname == 'CHFJPY' || cname == 'AUDJPY' || cname == 'XAGUSD' || cname == 'EOSUST' || cname == 'EOS'){
           leng = 3
         }else if(cname == 'XAUUSD' || cname == 'BTCUST' || cname == 'ETHUST' || cname == 'LTCUST' || cname == 'BCHUST' || cname == 'BTC' || cname == 'ETH' || cname == 'LTC' || cname == 'BCH'){
           leng = 2
         }else if(cname == 'TRX' || cname == 'TRXUST'){
           leng = 6
         }else{
           if(defval){
             if(defval.toString().indexOf(".") > -1){
               if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
                 leng = defval.toString().split('.')[1].length;
               }
             }else{
               leng = 0
             }
           }
         }
       }else{
         if(defval){
           if(defval.toString().indexOf(".") > -1){
             if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
               leng = defval.toString().split('.')[1].length;
             }
           }else{
             leng = 0
           }
         }
       }
       // defval = parseFloat(defval);
       return leng;
    },
    imgShow(e){
      this.imgIndex = e
    },
    mock(){
      this.$ajax.post(this.HOSTMn + '/api/index/register_vir').then((res) => {
        let resData = res.data.data;
        if(res.data.code == 200){
          setToken(resData.dg_token)
          localStorage.setItem('uid',resData.uid);
          localStorage.setItem('token',resData.dg_token);
          localStorage.setItem('mn_uid',resData.uid);
          localStorage.setItem('mn_token',resData.dg_token);
          localStorage.setItem('isMn',true);
          localStorage.setItem('temp_user',true)
          this.$toast.center(this.$t('langNew.cjmnzhcg'));
          setTimeout(() => {
            this.$router.push('/ldcoin?tradeIdx=0');
            // window.location.reload();
          }, 500)
        }else{
            // this.$toast.center(res.data.msg);
            return;
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    settime(){
      this.downTimer = setInterval(() => {
        var msg = {
          main_type: this.bzType,
          utime: new Date()
        };
        this.websocketsend(JSON.stringify(msg));
      }, 30000);
    },
    startFn(index) {
      let counters = document.querySelectorAll(".counter"+index); //获取到三个counter盒子
      counters.forEach((item) => {
        item.innerText = "0"; //记录分数变化的变量，初始值为0
        const updateData = () => {
          const data = +item.getAttribute("data-set"); //获取到元素中绑定的数据
          const tmp = +item.innerText; //临时变量保存变化一次的数据量
          const changeData = data / 100; //设置改变的速率
          if (tmp < data) {
            //如果临时变量的值小于最终数据的值，那么就给元素进行数据相加
            item.innerText = `${Math.ceil(tmp + changeData)}`; //值数相加，然后进行取整
            setTimeout(updateData, 1); //定时器传入回调函数目的在于动态变化
          } else {
            item.innerText = data; //不满足条件后，证明得到了最终数据，直接渲染
          }
        };
        updateData(); //调用函数，启动函数
      });
    },
    // getNewList(){
    //   let params = {
    //     page: 1,
    //     limit: 5
    //   }
    //   this.isLoad = true
    //   this.$ajax.get('/web/getStocknews',{params}).then((res) => {
    //     this.isLoad = false
    //     let resData = res.data.data.data;
    //     if(resData.length > 0){
    //         this.newList = resData;
    //     }
    //   }).catch(function(err){
    //       console.log(err)
    //   });
    // },
    getNewList() {
      // this.isLoad = true;
      let params = {
        limit: this.pageSize,
        page: this.page
      }
      this.$ajax.get('/api/index/newsList',params).then((res) => {
          let resData = res.data.data;
          this.newList = resData;
      }).catch(function(err){
          console.log(err)
      })
      // getStocknews(params).then(res => {
      //     this.isLoad = false;
      //     // this.total = res.total;
      //     this.newList = res.data || [];

      //     setTimeout(() => {
      //       // 旧版的横向轮播
      //       this.swiper1 = new Swiper('.swiper-container1',{
      //           slidesPerView: 3,//显示多少个item
      //           spaceBetween: 30,
      //           autoplay:false,
      //           loop: false,
      //           observer:true,  //修改swiper自己或子元素时，自动初始化swiper
      //           observeParents:true,  //修改swiper的父元素时，自动初始化swiper
      //           autoplay: {
      //               delay: 3000,
      //               disableOnInteraction: false
      //           },
      //           pagination: {
      //             el: '.swiper-pagination',
      //             clickable: true,
      //           },
      //           on:{
      //               // click: ()=>{
      //               //     let swiper = this.$refs.mySwiper1.$swiper;
      //               //     let i = JSON.parse(this.swiper1.clickedSlide.attributes['data-index'].nodeValue);
      //               //     vm.bannerLink(i);
      //               // }
      //           },
      //       })
      //     }, 0)
      // })
    },
    path(path){
      if(path == '/authenticationrj'){
        if(this.token){
          if(this.isMn){
            this.$toast.center(this.$t('请切换到真实账户'));
            setTimeout(()=>{
              this.$router.push({ path: '/login' });
            },1000)
          }else{
            this.$router.push({ path: path });
          }
        }else{
          this.$toast.center(this.$t('请切换到真实账户'));
          setTimeout(()=>{
            this.$router.push({ path: '/login' });
          },1000)
        }
      }else{
        this.$router.push({ path: path });
      }
    },
    // playVideo(){
    //   this.isVideoBg = false;
    //   const video = this.$el.querySelector('video');
    //   if (video) {
    //     video.play();
    //   }
    // },
    // getParam(){
    //   getParam().then(res => {
    //     for(var i=0;i< res.length; i++){
    //       if(res[i].key == 'android_link'){
    //         this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }else if(res[i].key == 'ios_link'){
    //         this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }else if(res[i].key == 'tf_link'){
    //         this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }else if(res[i].key == 'online_service'){
    //         localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
    //       }else if(res[i].key == 'online_service2'){
    //         localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
    //       }else if(res[i].key == 'ios_link_2'){
    //         this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }else if(res[i].key == 'ios_current_link'){
    //         this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }else if(res[i].key == 'tb_eth_video_link'){
    //         this.videoUrl = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
    //       }
    //     }
    //   });
    // },
    jumpUrl(url){
      this.$router.push(url);
    },
    showhover(e){
      this.hover = e
    },
    hidehover(){
      this.hover = 0
    },
    getNewTimeshar(){
      let that = this
      // let symbolArr = null;
      // if(this.tabIndex == 0){
      //   symbolArr = ["XAU","BRT","XAG"]
      // }else if(this.tabIndex == 1){
      //   symbolArr = ["OILFUT","NYMEX","NG","XPD","PTB"]
      // }else{
      //   symbolArr = ["btc","eth","doge","space","eos"]
      // }
      let symbolArr = ["btc","eth","doge","eos","ltc"];

      for (let item of symbolArr) {
          $.ajax({
              url: window.GLOBAL.HOST + 'web/new_timeshar?symbol=' + item.toLowerCase() +'usdt&period=1min',
              type:'get',
              success: function(res){
                if(res.data&&res.data.length){
                  that.trendArr[item] = res.data.map(item=>{
                    return Number(item.Close)
                  })
                  // console.log(that)
                  // console.log(that.trendArr)
                }
              }
          })
      }
    },
    jump(path){
      if(path=='/deal_c'){
        localStorage.setItem('type',2)
      }
      if(path=='/deal'){
        localStorage.setItem('type',1)
      }
      if(path=='/deal_jg'){
        localStorage.setItem('type',3)
      }
      if(path=='/preciousMetal'){
        localStorage.setItem('type',2)
      }
      if(path=='/contractTransaction'){
        localStorage.setItem('type',3)
      }
      this.$router.push({ path: path });
    },
    move() {
      this.lClass = this.iconDirection ? 'l2' : ''
      this.rClass = this.iconDirection ? 'r2' : ''
      this.type = this.iconDirection ? 'card' : ''
      this.iconDirection = ! this.iconDirection
    },
    tab(i,type){
      this.tabIndex = i;
      this.bzType = type;
      this.usdtList = [];
      // if(i==3){
      //   this.sort(this.usdtList.concat([]))
      // }else{
        // this.getmarketList();
      // }
      this.getCurrency();
      this.websocketonopen();
    },
    sort(data) {
      data.sort(function(a,b){
        return Number(a.grow) - Number(b.grow)
      }).reverse();
      this.currencyList = [];
      this.usdtList = data;
      for(var jj in data){
        this.currencyList[this.usdtList[jj].currency] = [this.usdtList[jj].change] ;
      }
    },
    link(cname) {
      localStorage.setItem('type',2)
      // this.$router.push({ path: '/deal_c', query: { symbol: a ,selfType : type} })
      this.$router.push('/ldcoin?cname=' + cname)
      // if(type == 1){
      //   localStorage.setItem('type',3)
      //   this.$router.push({ path: '/deal_c', query: { symbol: a ,selfType : type} })
      // }else{
      //   localStorage.setItem('type',3)
      //   this.$router.push({ path: '/contractTransaction', query: { symbol: a,selfType : type } })
      // }
    },
    more() {
      this.$router.push({ path: '/market', query: {  } })
    },
    register() {
      this.$router.push({ path: '/register', query: { v: this.value } })
    },
    getmarketList() {
      let that = this
      getmarketList({id:1,type:this.bzType}).then(res => {
        this.usdtList = res;
        this.oldList = res;
        this.currencyList = [];
        for (var curr in res){
          this.currencyList[this.usdtList[curr].currency] = [this.usdtList[curr].change,this.usdtList[curr].symbol];
        }
      });
    },
    getCurrency(){
       let params = {
         main_type: this.bzType
       }
       var url = JSON.parse(localStorage.getItem('isMn')) ? this.HOSTMn + '/api/index/getCurrency' : '/api/index/getCurrency';
       this.$ajax.post(url,params).then((res) => {
         if(res.data.code == 200){
           let resData = res.data.data;
           if(this.currencyAll){
             let listData = resData.map(item =>{
               if(this.currencyAll[item.small_name] != undefined){
                 var obj = {change_rate: this.currencyAll[item.small_name].change_rate,new_price:this.currencyAll[item.small_name].now_price,new_price1:this.currencyAll[item.small_name].now_price};
                 item = { ...item,...obj };
                 return item
               }else{
                 var obj = {change_rate: 0,new_price:0,new_price1:0};
                 item = { ...item,...obj };
                 return item
               }
             });
             this.usdtList = listData;
           }else{
             let listData = resData.map(item =>{
               var obj = {change_rate: 0,new_price:0,new_price1:0};
                 item = { ...item,...obj };
                 return item
             });
             this.usdtList = listData;
           }
           // if(this.tabIdx == 0){
           //   this.list = this.list.filter(item => item.isCollect == true);
           //   if(this.list.length == 0){
           //     var zxData = JSON.parse(localStorage.getItem('whList'));
           //     this.list = zxData.map(item =>{
           //       var obj = {change_rate: this.currencyAll[item.small_name].change_rate,now_price:this.currencyAll[item.small_name].now_price,isCollect: this.collectArr.indexOf(item.cname) === -1 ? false: true};
           //       item = { ...item,...obj };
           //       return item
           //     });
           //   }
           // }
           // if(this.list.length > 0){
           //     this.isNoData = false;
           // }else{
           //     this.isNoData = true;
           // }
           // this.isLoad = false;
         }else if(res.data.code == 20001){
           if(JSON.parse(localStorage.getItem('isMn'))){
             this.$toast.center(this.$t('langNew.mnts'));
           }
           this.$router.push('/login')
         }
       }).catch(function(err){
           console.log(err)
       })
     },
    initWebSocket(){ //初始化weosocket
				const wsuri = this.webSocketAll;
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
				},
				websocketonopen(){ //连接建立之后执行send方法发送数据
          if(this.websock.readyState === 1){
            var msg = {
              main_type: this.bzType,
              utime: new Date()
            };
            this.websocketsend(JSON.stringify(msg));
          }
				},
				websocketonerror(){//连接建立失败重连
					this.reconnect();
				},
				websocketonmessage(e){ //数据接收
        let msg = e.data;
        if (typeof msg === 'string' && msg != 'success') msg = JSON.parse(msg);
          if(msg){
            if(typeof msg === 'object'){
              this.currencyAll = msg;
              let listData = this.usdtList.map(item =>{
                var obj = {change_rate: this.currencyAll[item.small_name].change_rate,new_price:this.currencyAll[item.small_name].now_price,new_price1: this.currencyAll[item.small_name].now_price};
                item = { ...item,...obj };
                return item
              });
              this.usdtList = listData;
            }
          }else{

          }
      },
				websocketsend(Data){//数据发送
					this.websock.send(Data);
				},
				websocketclose(e){  //关闭
					console.log('断开连接',e);
				},
          reconnect() {
        var tt;
        if (this.lockReconnect) {
          return;
        }
        this.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        tt && clearTimeout(tt);
        tt = setTimeout(() => {
          // console.log('执行断线重连...')
          this.initWebSocket();
          this.lockReconnect = false;
        }, 1000);
      },
    bannerLink(i){
      // let id = this.bannerList[i].id;
      // let content = this.bannerList[i].content;
      // if(id){
      //   if(this.filterHtmlTag(content)){
      //     this.$router.push({
      //       path: "/bannerDetail",
      //       query: { id }
      //     });
      //   }
      // }
    },
    filterHtmlTag(msg){
      var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
          msg = msg.replace(/[|]*\n/, '') //去除行尾空格
          msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
          return msg;
    },
    notice(id) {
      this.$router.push({
        path: "/notice",
        query: { id }
      });
    },
    getClass(grow) {
      return parseFloat(grow) < 0 ? "down" : "";
    },
    change(index) {
      this.index = index;
    },
    downLoad(){
      this.$router.push('/downLoad');
    },
    goDetail(){
      sessionStorage.setItem("isNoticeShow", true);
      let id = this.noticeId;
			 this.$router.push({
        path: "/notice",
        query: { id }
      });
		},
    // getDetail(id){
    //   getText({id:id}).then(res => {
    //     if (res && res.content) {
    //       this.noticeHtml = res.content;
    //     }
    //   })
    // },
    noticeClose(){
			if(this.isNoticeShow != null){
				this.isNotice = true;
				sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
		},
  },
  beforeDestroy(){
    clearInterval(this.downTimer);
    this.downTimer = null;
  },
  destroyed() {
    clearInterval(this.downTimer);
    this.downTimer = null;
    // this.websock.close();
  }
};
</script>

<style lang="scss" scoped>
  .table-body .change{
      color: #00994e;
      font-size: .2rem;
  }
   .table-body .sell{
     padding: .24rem 0;
     background: #fff;
     border-radius: .12rem;
    color: #00994e;
    font-size: .2rem;
  }
   .table-body .buy{
     padding: .24rem 0;
     background: #fff;
     border-radius: .12rem;
    color: #00994e;
    font-size: .2rem;
  }
  .table-body .bg{
    color: #f22748;
    background: #fdedee;
  }
      .regSteps__wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin-top: .6rem;
      }

      .regSteps__shape {
            position: relative;
            display: grid;
        // display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border-radius: 93px;
        width: 100%;
        box-shadow: 0px 14px 109px 0px rgba(0, 0, 0, 0.09);

        grid-template-columns: repeat(3, max-content);
                grid-column: 1 / -1;
                grid-row: unset;
                margin: 0 calc(12.5% - 16px);
                gap: 32px;
      }

      .regSteps__shape:before {
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          bottom: unset;
          width: unset;
          height: 0;
          border: 1px dashed #000;
          content: "";
      }

      .regSteps__item {
        display: flex;
        flex-direction: column;
          padding: 16px;
          border-radius: 50%;
          z-index: 1;
          background: #fff;
      }

      .regSteps__item:first-child:before {
          left: 50%;
          top: 50%;
          width: 300%;
          height: 300%;
          transform: translate(-50%,-50%)
      }

  .btn-app{
    width: 80%;
    height: .9rem;
    line-height: .9rem;
    text-align: center;
    box-shadow: 0px 8px 18px 0px
      rgba(154, 154, 154, 0.5);
    border-radius: 10px;
    font-size: .28rem;
  }
  .counter1,.counter2,.counter3{
    font-size: .40rem;
    font-weight: bold;
  }
  .my-pagination-clickable{
    text-align: end;
    padding-right: 3rem;
    bottom: 40px !important;
    >>> .swiper-pagination-bullet-active{
      background: #fcd535 !important;
    }
  }
  .img-news{
    width: 100%;
    height: 3rem;
    object-fit: cover;
    border-radius: 20px 20px 0 0;
  }
  .ai-box{
    background-color: #070e20;
    	box-shadow: 0px 14px 109px 0px
    		rgba(0, 0, 0, 0.09);
  }
  .bggreen{
        display: inline-block;
        width: 1.5rem;
        height: 30px;
        line-height: 18px;
        background-color: #bcedd6;
  }
  .bgred{
        display: inline-block;
        width: 1.5rem;
        height: 30px;
        line-height: 18px;
    background-color: #fedcd4;
  }
  .line4{
    .row1{display: flex;align-items: center;font-size: 0.32rem;font-weight: bold;
      .img1{width: 0.45rem;margin-right: 0.15rem;}
      .textb{
        .text1{color: #fcd535;}
        .text2{color: #444;}
      }
    }
  }
  .text3{display: flex;justify-content: center;align-items: center;background-color: #fcd535;
    margin: 0.3rem;padding: 0.2rem .4rem;border-radius: 3rem;
    .img1{width: 0.25rem;margin-left: 0.1rem;}
    .text3-1{font-size: 0.2rem;font-weight: bold;}
  }
  .textmn{
    margin: .3rem 0;
    background-color: #fff;
    border: 1px solid #000;
  }
  .sy-btn{
    width: 125px;
    	height: 45px;
    	background-color: #ffffff;
    	box-shadow: 0px 10px 30px 0px
    		rgba(0, 0, 0, 0.14);
    	border-radius: 45px;
    	border: solid 1px #8c8c8c;
      font-size: 14px;
      color: #000;
  }
  .c-858b99{
    color: #858b99;
  }
  .xz{
    // width: 170px;
    padding:0 20px;
    height: 50px;
    border-radius: 10px;
  }
  .bg-fcd437{
    background-color: #fcd535;
  }
  .bg-f3f5f7{
    background-color: #f3f5f7;
  }
  .video-box,#video{
    position: relative;
    // width: 3.87rem;
    width: 90%;
    height: 3.14rem;
    border-radius: .25rem;
  }
  .video-bg{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    // width: 3.87rem;
    width: 90%;
    height: 3.14rem;
    border-radius: .25rem;
  }
  .bg-new{
    // background: #ededed;
  }
  .bg-list1{
    box-shadow: 0px 14px 109px 0px
    	rgba(0, 0, 0, 0.09);
  }
  .bg-list{
    background-color: #ffffff;
    	box-shadow: 0px 14px 109px 0px
    		rgba(0, 0, 0, 0.09);
    	border-radius: 15px;
      // padding: 30px;
  }
  .li-hover:hover{
        box-shadow: 0px 11px 51px 0px rgba(0, 0, 0, .14);
  }
  // .bg-hover:hover{
  //   background-color: #212228;
  // }
  // .bg-hover:hover .op-hover{
  //   opacity: 1;
  // }
  // .input-reg{
  //   color: #a8a8a8;
  //   text-indent: .2rem;
  // }
  // .icon-mobile-show{
  //   display: none;
  // }
  // .android-btn:hover{
  //   background-color: #000;
  //   cursor: pointer;
  //   border: none;
  //   div{
  //     color: #fff;
  //   }
  //   .icon-mobile-show{
  //     display: block;
  //   }
  //   .icon-mobile-hide{
  //     display: none;
  //   }
  // }
  // .ios-btn:hover{
  //   background-color: #000;
  //   cursor: pointer;
  //   border: none;
  //   div{
  //     color: #fff;
  //   }
  //   .icon-mobile-show{
  //     display: block;
  //   }
  //   .icon-mobile-hide{
  //     display: none;
  //   }
  // }
  .android-btn,.ios-btn{
    border: 1px solid #000;
    padding:10px 0;
  }
  .a-hover{
    // position: relative;
    // height: .94rem;
  }
  .a-hover:hover{
    .icon-mobile-show{
      display: block;
    }
  }
  .qr-android{
    position: absolute;
    top: 45%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 20px;text-align:center;background: #fff
  }
  .qr-ios{
    position: absolute;
    top: 45%;
    left: 15%;
    box-shadow: 0px 0px 0px 6px #eee;height: 132px;width: 132px;margin: 10px 0 0 30px;text-align:center;background: #fff
  }
  .svg-img1{
    top: 30px;
    right: 40px;
  }
  .svg-img1 img{
    width: 7.51rem;
    height: 5.27rem;
    // width: 7.878rem;
    // height: 16.406rem;
  }
  // .pc-bg{
  //   display: flex;
  //   width:auto;
  //   height:700px;
  //   background-color: #f5f5f5;
  //   flex-direction: column;
  // }
  // .pc-bg-img{
  //   width: 1263px;
  //   height: 880px;
  //   margin: -150px auto 0;
  //   background-image: url('../assets/new3/bg3.0733f40b.png');
  //   background-size: 100% 100%;
  // }
  .fill-red >>> path {
    fill:rgba(255,0,0,0.5);
  }
  .fill-green >>> path {
    fill:rgba(0,128,0,0.5);
  }
  .bg-img{
    background-image: url('../assets/home/picture1.png');
    background-size: 100% 100%;
  }
  .bg-hover:hover{
    // background-color: #ffffff;
    box-shadow: 0px 11px 51px 0px rgba(0, 0, 0, .14);
  }
  .bg-hover:hover .op-hover{
    opacity: 1;
  }
  .input-reg{
    color: #a8a8a8;
    text-indent: .2rem;
  }
  .icon-mobile-show{
    display: none;
  }
  .android-btn:hover{
    background-color: #fcd535;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }
  .ios-btn:hover{
    background-color: #fcd535;
    cursor: pointer;
    border: none;
    div{
      color: #fff;
    }
    .icon-mobile-show{
      display: block;
    }
    .icon-mobile-hide{
      display: none;
    }
  }

.rise {
  text-align: center;
}
.fall {
  text-align: center;
}
.rise span,.fall span{
  display:inline-block;
  width: 83px;
  height: 32px;
  line-height: 32px;
  background: rgba(220, 86, 86, .13);
  border-radius: 2px;
}
.coin-li-head > .rise span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #27af87 !important;
}
.coin-li-head > .fall span{
  width:70px;
  height:24px;
  line-height:24px;
  color: #e05a5a !important;
}

  .box03{ width:100%;height: 8.5rem;}
  .box03 .box{ margin:auto;}
  .box03 .title{ float:left; color: #000000;font-size:40px; line-height:50px; font-weight:bold;}
  .box03 .tab_menu{ display:block;}
  .box03 .tab_menu li{ display:block; font-size:.34rem; line-height:.73rem; height:.73rem; border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:30px; color:#7d7d7d; cursor:pointer;}
  .box03 .tab_menu li.cur{
    padding: 0 10px;
  	height: .73rem;line-height: .73rem;text-align: center;
  	background-color: #fcd535;
  	border-radius: .1rem;color:#000;}
  .box03 .tabox{ width:100%; float:left; margin-top:30px;}
  .box03 .tabox .cont{ width:100%;}
  .box03 .tabox .cont .th{ width:100%; overflow:hidden; font-size:16px; color:#7d7d7d;}
  .box03 .tabox .cont .td{ float:left; line-height:60px; height:60px;}
  .box03 .tabox .cont .th .td:nth-child(1){ text-align: left;}
  .box03 .tabox .cont .tr .td:nth-child(1){ text-align: left;}
  .box03 .tabox .cont .td2{ width:19%; }
  .box03 .tabox .cont .td1{ width:16.2%;}
  .box03 .tabox .cont .tr{ overflow:hidden; font-size:.2rem; border-radius:5px; color:#000000;}
  .box03 .tabox .cont .tr:nth-child(2n){ background-color:transparent;}
  .box03 .tabox .cont .tr .td2{ text-align:right; box-sizing:border-box;}
  .box03 .tabox .cont .tr .td1 a:hover{ color:#00d5fd;}
  .box03 .tabox .cont .td2 img{ width:.4rem; border-radius:100%; overflow:hidden; height:.4rem; margin-right:10px; display:block; float:left; margin-top:17px;}
  .red{ color:red;}
  .green{ color:green;}

// $nav-height: 3*16/100 rem;
// $font-size-mini:.75*16/100 rem;
// $font-size-small: .875*16/100 rem;
// $font-size:1*16/100 rem;
// $font-size-large:1.125*16/100 rem;
// $font-size-big:1.6*16/100 rem;
// $blue:#2558d9;
// $green:#4db872;
// $red:#ee6560;
// $aaa: #aaa;
// $eee:#eee;
// $c3: #333;
// $c6: #666;


// $color: #dbdde1;
// $hoverColor: #dbdde1;
// $activeColor: #dbdde1;
// $borderColor:#2558d9;

// $nav-background-color: #0e1936;
// $background-color:#0e1014;

// $background:#000000;
// $background-blue:#2558d9;
// $background-green:#0d8551;

// .banner{ width:100%; height:540px; background-position:center; background-repeat:no-repeat; position:relative; z-index:0;}
// .banner .box{ width:1200px; position:absolute; top:50%; left:50%; transform:translateX(-50%) translateY(-50%);}
// .banner .box .wen{ width:520px; float:right;}
// .banner .wen b{ font-size:40px; line-height:60px; display:block; color:#000000;}
// .banner .wen p{ width:100%; margin-top:10px; font-size:18px; line-height:28px; color:#000000;}
// .banner .ser{ clear:right; float:right; width:440px; margin:30px 0; margin-right:80px; border:1px solid #00d5fd; border-radius:5px;}
// .banner .ser input{ background-color:#17191a; width:338px; height:44px; line-height:44px; display:block; float:left; text-indent:20px; font-size:14px; border-radius:5px; overflow:hidden; color:#000000;}
// .banner .ser a{ width:100px; height:44px; line-height:44px; display:block; float:left; text-align:center; color:#000000; background-color:#00d5fd; font-size:14px; overflow:hidden;}
// .banner{
//   background-image: url('../assets/new/banner.jpg');
// }
// .box01{ width:100%; margin-top:70px;}
// .box01 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box01 .box .left{ width:600px; margin-left:200px;}
// .box01 .box .left .b01{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box01 .box .left .b02{ font-size:16px; color:#99b3da; line-height:26px; margin-top:20px;}
// .box01 .box .left .b03{ width:100%; margin-top:30px;}
// .box01 .box .left .b03 p{ display:block; float:left; margin-right:50px;}
// .box01 .box .left .b03 p b{ display:block; color:#00d5fd; font-size:40px;}
// .box01 .box .left .b03 p span{ display:block; color:#99b3da; font-size:16px; line-height:26px;}
// .box01 .box .right{ width:400px; border-radius:10px;}
// .box01 .box .right img{ width:100%; display:block;}

// .box02{ width:100%; margin-top:70px;}
// .box02 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box02 .box .left{ width:700px; margin-right:100px;}
// .box02 .box .left .b01{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box02 .box .left .b02{ font-size:16px; color:#99b3da; line-height:26px; margin-top:20px;}
// .box02 .box .left .b03{ width:100%; margin-top:30px;}
// .box02 .box .left .b03 p{ display:block; float:left; margin-right:50px;}
// .box02 .box .left .b03 p b{ display:block; color:#00d5fd; font-size:40px;}
// .box02 .box .left .b03 p span{ display:block; color:#99b3da; font-size:16px; line-height:26px;}
// .box02 .box .right{ width:400px; border-radius:10px;}
// .box02 .box .right img{ width:100%; display:block;}

// .box03{ width:100%;}
// .box03 .box{ width:1200px; margin:auto;}
// .box03 .title{ float:left; color: #000000;font-size:40px; line-height:50px; font-weight:bold;}
// .box03 .tab_menu{ display:block;}
// .box03 .tab_menu li{ display:block; font-size:.34rem; line-height:.73rem; height:.73rem; border-bottom:2px solid rgba(0,0,0,0); float:left; margin-right:30px; color:#7d7d7d; cursor:pointer;}
// .box03 .tab_menu li.cur{ width: 1.6rem;
// 	height: .73rem;line-height: .73rem;text-align: center;
// 	background-color: #fcd535;
// 	border-radius: .1rem;color:#000;}
// .box03 .tabox{ width:1200px; float:left; margin-top:30px;}
// .box03 .tabox .cont{ width:100%;}
// .box03 .tabox .cont .th{ width:100%; overflow:hidden; font-size:16px; color:#7d7d7d;}
// .box03 .tabox .cont .td{ float:left; line-height:60px; height:60px;text-align: right;}
// .box03 .tabox .cont .th .td:nth-child(1){ text-align: left;}
// .box03 .tabox .cont .tr .td:nth-child(1){ text-align: left;}
// .box03 .tabox .cont .td2{ width:19%; }
// .box03 .tabox .cont .td1{ width:13.5%; }
// .box03 .tabox .cont .tr{ overflow:hidden; font-size:14px; border-radius:5px; color:#000000;}
// .box03 .tabox .cont .tr:nth-child(2n){ background-color:transparent;}
// .box03 .tabox .cont .tr .td2{ text-align:right; box-sizing:border-box;}
// .box03 .tabox .cont .tr .td1 a:hover{ color:#00d5fd;}
// .box03 .tabox .cont .td2 img{ width:26px; border-radius:100%; overflow:hidden; height:26px; margin-right:10px; display:block; float:left; margin-top:17px;}
// .red{ color:red;}
// .green{ color:green;}

// .box04{ width:100%; margin-top:70px;}
// .box04 .box{ width:1200px; margin:auto; display:flex; align-items:center;}
// .box04 .box .left{ width:680px; margin-right:120px;}
// .box04 .box .left .title{ font-size:40px; font-weight:bold; color:#000000; line-height:50px;}
// .box04 .box .left .wen{ font-size:18px; line-height:28px; color:#000000; margin-top:10px; opacity:0.3;}
// .box04 .box .left .list{ display:block; margin-top:15px;}
// .box04 .box .left .list li{ display:block; overflow:hidden; margin-top:20px;}
// .box04 .box .left .list li b{ font-size:24px; line-height:34px; color:#000000; display:block; overflow:hidden;}
// .box04 .box .left .list li p{ font-size:16px; line-height:26px; color:#99b3da; display:block; overflow:hidden; margin-top:10px;}
// .box04 .box .right{ width:400px;}
// .box04 .box .right img{ width:100%; display:block;}

// .box05{ width:100%; margin-top:70px;}
// .box05 .box{ width:1200px; margin:auto;}
// .box05 .box .left{ width:500px; float:right;}
// .box05 .box .left .wen{ padding:30px; background-color:#00d5fd; border-radius:10px;}
// .box05 .box .left .b01{ font-size:40px; font-weight:bold; color:#333; line-height:50px;}
// .box05 .box .left .b02{ font-size:24px; color:#333; line-height:34px; margin-top:20px;}
// .box05 .box .left .b03{ font-size:18px; color:#666; line-height:28px; margin-top:10px;}
// .box05 .box .left .b04{ width:100%; margin-top:30px;}
// .box05 .box .left .b04 a{ display:block; float:left; margin:0 30px 15px 0;}
// .box05 .box .left .b04 a:last-child{ margin-right:0;}
// .box05 .box .left .b04 a img{ display:block; margin:auto;}
// .box05 .box .left .b06{ font-size:30px; color:#000000; line-height:40px; margin-top:45px;}
// .box05 .box .left .b05{ display:block; margin-top:30px;}
// .box05 .box .left .b05 dt{ display:block; float:left; width:190px; height:50px; border:1px solid #000000; border-radius:5px; text-align:center; margin-right:30px; font-size:18px; line-height:50px;}
// .box05 .box .left .b05 dt a{ color:#000000;}
// .box05 .box .left .b05 dt a:hover{ color:#00d5fd;}
// .box05 .box .left .b05 dd{ display:block; float:left; width:190px; height:50px; border:1px solid #00d5fd; border-radius:5px; text-align:center; margin-right:30px; font-size:18px; line-height:50px; background-color:#00d5fd;}
// .box05 .box .left .b05 dd a{ color:#333;}
// .box05 .box .right{ width:640px; float:left;}
// .box05 .box .right img{ width:100%; display:block;}

/*广告*/
// .gbox{ width:100%; margin-top:30px; position:relative; z-index:2;}
// .gbox .box{ width:1200px; margin:auto;}
// .gbox .box .swiper-slide{ width:100%; display:block; overflow:hidden; border-radius:10px;}
// .gbox .box img{ width:100%; display:block;}
// .gbox .box .swiper-pagination{ width:100%; margin-top:25px; text-align:center; line-height:10px;}
// .gbox .box .swiper-pagination span{ display:inline-table; width:40px; height:5px; background-color:#999; margin:0 10px; border-radius:4px; cursor:pointer;}
// .gbox .box .swiper-pagination span.swiper-pagination-bullet-active{ background-color:#00d5fd;}
  .notice-alert-wrap{
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 12;
    width: 600px;
    padding: 0 6px;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
    transform: translate(-50%,-50%);
  }
  .notice-alert-wrap .title{
    padding: 10px;
    color: #000;
    font-size: 16px;
    text-align: center;
  }
  .notice-alert-wrap .cont{
    min-height: 80px;
    max-height: 400px;
    padding: 10px;
    color: #666;
    font-size: 13px;
    word-break: break-word;
    overflow-y: auto;
  }
  .notice-alert-wrap .notice-btn{
    width: 280px;
    height: 36px;
    margin: 10px auto 20px;
    color: #fff;
    line-height: 36px;
    border-radius: 4px;
    background: #fcd535;
    cursor: pointer;
    text-align: center;
  }
  .notice-alert-wrap .btn-close{
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    cursor: pointer;
  }
//   // 公告
  .notice-wrap{
    width: 100%;
  }
  .notice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    .notice-tips{
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
    .notice-tips .icon{
      width: 24px;
    }
    .notice-new{
      width: .6rem;
      height: .25rem;
      background-color: #fcd535;
      border-radius: .02rem;
    }
    .notice-more{
      color: #fcd535;
      font-size: .144rem;
      cursor: pointer;
    }
    // .notice-more:hover{
    //   color: #000000;
    //   font-size: 1*16/100 rem;
    // }
    .notice-item{
      flex: 1;
    }
    & > .notice-item {
      font-size: .12rem;
      color: #000000;
      overflow: hidden;
      word-break: keep-all;
      text-align: center;
      span {
        display: inline-block;
        position: relative;
        padding: 0 2em 0 1.5em;
        color: #000000;
        cursor: pointer;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #fcd535;
        }
        & + span {
          border-left:1px solid #c8c8c8;
          padding-left:.3rem;
          margin-right: 1.5rem;
          // &::before {
          //   content: "/";
          //   position: absolute;
          //   left: -0.5em;
          //   color: #54748f;
          // }
        }
      }
    }
  }
// .swiper-pagination{
//     width:100%;
//     bottom: -25px;
//     left:0;
//     right:0;
//     margin:auto;
//   }
//   .swiper-pagination-bullet{
//     background: #999;
//     opacity: 1;
//     width: 40px!important;
//     height: 5px!important;
//     border-radius: 4px;
//     margin:0 4px;
//     color: transparent;
//   }
//   .swiper-pagination-bullet-active{
//     background: #0d73f2;
//   }
</style>
<style>
  .absolute .swiper-pagination{
    display: flex;
    left: 1rem;
    top:.65rem
  }
  .absolute .swiper-pagination .swiper-pagination-bullet{
    font-size: .26rem;
    color: #9f9f9f;
    width: .4rem;
    transform-origin: 0 0;
    transform: rotate(-90deg);
    background: transparent;
    opacity: 1;
  }
  .absolute .swiper-pagination .swiper-pagination-bullet-active{
    background: transparent !important;
    font-size: .41rem;
    color: #000000;
  }
  .absolute .swiper-button-prev{
    width: .7rem;
    height: .7rem;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: .14rem;
    background-image: url(../assets/home/arrow-up.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }
  .absolute .swiper-button-next{
    width: .7rem;
    height: .7rem;
    background-color: #ffffff;
    border-radius: 10px;
    background-image: url(../assets/home/arrow-down.png);
    background-size: .3rem .3rem;
    transform: rotate(-90deg)
  }



   .s_ticker {
      height: 120px;
      mask-image: linear-gradient(90deg,transparent 0,#000 25%,#000 75%,transparent);
      -webkit-mask-image: linear-gradient(90deg,transparent 0,#000 25%,#000 75%,transparent);
      position: relative
  }

   .s_ticker .s_ticker_box {
      position: absolute;
      left: 0;
      height: 100%;
      display: flex;
      align-items: center;
      animation: ticker_animate 30s linear infinite;
  }

   .s_ticker .s_ticker_box:hover {
      animation-play-state: paused
  }

   .s_ticker .s_ticker_box ul {
      padding: 0;
      margin: 0;
      display: flex
  }

   .s_ticker .s_ticker_box span:hover {
      background: hsla(0,0%,39%,.05)
  }

   .s_ticker span {
      padding: 0 20px;
      border-radius: 30px;
      height: 60px;
      display: inline-flex;
      align-items: center;
      flex-wrap: nowrap;
      margin-right: 30px
  }
  .mui-18oeoue {
      background-color: #ececec;
      overflow: hidden;
  }
  .mui-1k8stw6 {
      margin: 0px;
      font-weight: 400;
      line-height: 1.5;
      background-color: #fff;
  }
   .s_ibit_block {
      height: 100%;
      width: 100%;
      transition: all .5s ease-in-out .5s;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative
  }

   .s_ibit_block .s_banner_left_001 {
      transform: translate(-552px,-223px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_002 {
      transform: translate(-430px,-57px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_003 {
      transform: translate(-323px,7px) rotate(3turn)
  }

   .s_ibit_block .s_banner_left_004 {
      transform: translate(-482px,147px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_001 {
      transform: translate(490px,-250px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_002 {
      transform: translate(340px,-180px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_003 {
      transform: translate(250px,-70px) rotate(3turn)
  }

   .s_ibit_block .s_banner_right_004 {
      transform: translate(420px) rotate(3turn)
  }

   .animate_img_group {
      height: 814px;
      position: relative;
      z-index: 1;
      width: 385px;
      transform-style: preserve-3d;
      transition: 1s ease-in-out;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transform: perspective(1000px) rotateY(0deg)
  }

   .animate_img_group.hover {
      transform: rotateY(180deg)
  }

   .animate_img_group .animate_img {
      transform: rotateY(0deg);
      position: absolute;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden
  }

   .animate_img_group .light_img {
      transform: rotateY(180deg)
  }

   .animate_attempt_group_gsap {
      transform: perspective(2500px) translateX(0) translateY(-20px) scale(.98) rotate(0deg) rotateX(20deg) rotateY(0deg) translateZ(0);
      transform-style: preserve-3d;
      transition: .3s ease-in-out;
      transform-origin: center bottom；
  }

   .animate_attempt_group {
      height: 713px;
      position: relative;
      z-index: 1;
      width: 1002px;
      transform-style: preserve-3d;
      transition: .5s ease-in-out;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      transform: rotateY(0deg)
  }

   .animate_attempt_group.hover {
      transform: rotateY(180deg)
  }

   .animate_attempt_group .animate_img {
      transform: rotateY(0deg);
      position: absolute;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      left: 0;
      width: 100%
  }

   .animate_attempt_group .light_img {
      transform: rotateY(180deg)
  }

  .home-mobile .animate_img_group.hover {
      transform: none
  }

  .home-mobile .animate_img_group.hover img:first-of-type {
      display: none
  }

  .home-mobile .animate_img_group.hover img:nth-of-type(2) {
      display: inline-block;
      transform: none
  }

  @keyframes ticker_animate {
      0% {
          transform: translateZ(0)
      }

      to {
          transform: translate3d(-50%,0,0)
      }
  }

  @keyframes img_animate {
      0% {
          transform: translate(0)
      }

      50% {
          transform: translateY(10px)
      }

      to {
          transform: translate(0)
      }
  }
  .num-text{
    margin-bottom: .2rem;
    padding-bottom: .2rem;
    border-bottom: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue